<template>
    <el-input @input="input" v-bind="$attrs" :value="inputV">

    </el-input>
</template>

<script>
export default {
	data(){
		return {
			inputV:'',
		}
	},
	props:['value'],
	watch:{
		value(v){
			if(v && v.$in){
				this.inputV = v.$in.join(',');
			}else{
				this.inputV = '';
			}
		}
	},
	methods:{
		input(v){
			if(v){
				this.$emit('input',{$in:v.split(',')})
			}else{
				this.$emit('input','')
			}
		}
	}
}
</script>

